var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.42 10.8303C14.7129 11.1231 14.7129 11.598 14.42 11.8909L10.6556 15.6553L10.5299 15.7807C10.2367 16.0732 9.76183 16.0727 9.46927 15.7795L9.34522 15.6552L5.581 11.891C5.2881 11.5981 5.28811 11.1232 5.581 10.8303C5.87389 10.5374 6.34877 10.5374 6.64166 10.8303L9.25022 13.4389L9.25042 4.74959C9.25052 4.33538 9.58638 3.99966 10.0006 3.99976C10.4148 3.99985 10.7505 4.33571 10.7504 4.74992L10.7502 13.4394L13.3593 10.8303C13.6522 10.5374 14.1271 10.5374 14.42 10.8303Z",
    fill: "#808085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.ac6c143b.svg";
export { ForwardRef as ReactComponent };